export default __webpack_public_path__ + "static/heartopener_1-5ca4d1086a1ed0bfaebabafd4915cf7b.jpg";